import React, { useEffect, useState, useRef } from 'react';
import {
  Drawer,
  Box,
  Button,
  Typography,
  TextField,
  Switch,
  Checkbox,
  FormControlLabel,
  Chip,
  IconButton,
  CardActions,
  Alert,
  CardContent,
  InputAdornment,
  Stack
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ArchitectureOutlinedIcon from '@mui/icons-material/ArchitectureOutlined';
import CloseIcon from '@mui/icons-material/Close';
import axios from '../../api/axios';
import DeleteIcon from '@mui/icons-material/Delete';
import RoomIcon from '@mui/icons-material/Room';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import StickyNote2RoundedIcon from '@mui/icons-material/StickyNote2Rounded';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import { red, green } from '@mui/material/colors';

const GET_ORG = "/org/";
const SAVE_FILE = '/savefile/'
const SAVE_PDF_FILE = '/savePDF/'
const GET_BUILDERS = "/builder/";
const GET_PROJECTS = "/project/";
const GET_BUILDSTAGE = "/buildstage/";
const GET_ELEVATIONS = "/elevation/";
const GET_PLANOPTIONS = "/planoption/";
const GET_PLANNUMBERS = "/plannumber/";
const CREATE_PLAN = "/plan/";
const UPLOAD_DWG_FILE = "/uploadfile/"
const UPLOAD_PDF_FILE = "/uploadPDFfile/"

const AddPlan = ({ openModal, setOpenModal, addNewPlanToBuildersList, tableBuilders, 
  setHighlightPlanId, setSelectedBuilderId, selectedBuilderId }) => {

  const mainFieldWidth = 552;
  const secondaryFieldWidth = 528;
  const marginTopBetweenFields = 4;

  const [orgSettings, setOrgSettings] = useState(null);

  const initialFormValues = {
    builder: null,
    projectId: '',
    planNumber: '',
    lotLocation: '',
    anchorNotes: '',
    layout: '',
    planNotes: '',
    option: [],
    nonStandard: false,
    elevation: '',
    elevationId: '',
    buildStage: ''
  };

  const [formValues, setFormValues] = useState(initialFormValues);

  const [builders, setBuilders] = useState([])
  useEffect(() => {
    setBuilders(tableBuilders);
  }, [tableBuilders])

  const [saveLoading, setSaveLoading] = useState(false)

  const [builderLoading, setBuilderLoading] = useState(false);

  const [projects, setProjects] = useState([]);
  const [projectOpen, setProjectOpen] = useState(false);
  const [projectInputValue, setProjectInputValue] = useState("");
  const [projectLoading, setProjectLoading] = useState(false);

  const [confirmCloseDialog, setConfirmCloseDialog] = useState(false);
  const [showValidationAlert, setShowValidationAlert] = useState(false);
  const [errors, setErrors] = useState({ file: '' });
  const [value, setValue] = useState(null);

  const [buildStageValue, setBuildStageValue] = useState(null);
  const [buildStageLoading, setBuildStageLoading] = useState(false);
  const [buildStages, setBuildStages] = useState([]);
  const [selectedBuildStages, setSelectedBuildStages] = useState([]);

  const [planNumbers, setPlanNumbers] = useState([]);

  const [planLoading, setPlanLoading] = useState(false);

  const [planOptionValue, setPlanOptionValue] = useState([]);
  const [selectedPlanOptions, setSelectedPlanOptions] = useState([]);
  const [planOptions, setPlanOptions] = useState([]);
  const [planOptionLoading, setPlanOptionLoading] = useState(false);

  const [elevations, setElevations] = useState([]);
  const [elevationLoading, setelevationLoading] = useState(false);
  const [projectValue, setProjectValue] = useState(null);

  const alertRef = useRef(null);
  const builderInputRef = useRef(null);
  const projectInputRef = useRef(null);
  const planInputRef = useRef(null);
  const elevationInputRef = useRef(null);
  const layoutInputRef = useRef();
  const planOptionsInputRef = useRef();
  const planNotesInputRef = useRef(null);
  const buildStageInputRef = useRef(null);
  const anchorPlacementInputRef = useRef(null);
  const lotLocationInputRef = useRef(null);

  const [uploadStatus, setUploadStatus] = useState('');
  const [uploadError, setUploadError] = useState('');
  const [uploadLoading, setUploadLoading] = React.useState(false);

  const [pdfUploadStatus, setPdfUploadStatus] = useState('');
  const [pdfUploadError, setPdfUploadError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');

    axios.post(GET_ORG, {
      token,
      orgSettings: "true"
    })
    .then((res) => {
      const settings = res.data?.message?.settings;
      setOrgSettings(settings);
    })
    .catch((err) => {
      console.error("Error fetching org settings:", err);
    });

    setBuildStageLoading(true)
    axios.post(GET_BUILDSTAGE, {
      token: localStorage.getItem('token'),
      getBuildStage: 'true',
    })
    .then((response) => {
      const buildStageList = response.data?.message?.buildStages || [];
      buildStageList.sort((a, b) => a.sortOrder - b.sortOrder).map(stage => stage.buildStageName);
      setBuildStages(buildStageList);
    })
    .catch((error) => {
      console.error('Error fetching build stages:', error);
    })
    .finally(()=>{
      setBuildStageLoading(false)
    })
  }, [])

  useEffect(() => {
    const builderId = formValues.builder?.id;
    if (!builderId) return;

    // Reset form values related to builder when builder changes
    setFormValues((prev) => ({
      ...prev,
      project: "",
      planOption: null,
      elevation: "",
      planNumber: null,
    }));

    setProjectValue(null);
    setPlanOptions(null);

    // Clear existing options
    setProjects([]);
    setPlanOptions([]);
    setPlanNumbers([]);
    setElevations([]);

    setProjectLoading(true);
    axios.post(GET_PROJECTS, {
      token: localStorage.getItem('token'),
      getProjects: 'true',
      builderId,
    })
    .then((response) => {
      let projectList = response.data?.message?.projects || [];

      projectList = projectList
        .filter(p => typeof p.projectName === 'string' && (!p.archived || p.archived === false))
        .sort((a, b) => {
          const nameA = a.projectName;
          const nameB = b.projectName;

          // Extract numeric parts
          const numA = parseInt(nameA.match(/\d+/)?.[0] || "0", 10);
          const numB = parseInt(nameB.match(/\d+/)?.[0] || "0", 10);

          // Extract base (non-numeric) parts
          const baseA = nameA.replace(/\d+/g, '').trim();
          const baseB = nameB.replace(/\d+/g, '').trim();

          // Sort alphabetically by base name first, then numerically
          if (baseA === baseB) {
            return numA - numB;
          }

          return baseA.localeCompare(baseB);
        });

      setProjects(projectList);
    })
    .catch((error) => {
      console.error('Error fetching projects:', error);
    })
    .finally(() => {
      setProjectLoading(false);
    });


    setPlanLoading(true)
    axios.post(GET_PLANNUMBERS, {
      token: localStorage.getItem('token'),
      getPlanNumbers: true,
      builderId: builderId,

    })
    .then((response) => {
      const planNumber = response.data?.message?.planNumbers || [];

      // Sort the plan # alphanumerically by name
      const sortedPlanNumbers = [...planNumber].sort((a, b) =>
        a.planNumberName.localeCompare(b.planNumberName, undefined, { numeric: true, sensitivity: 'base' })
      );
      setPlanNumbers(sortedPlanNumbers);
    })
    .catch((error) => {
      console.error('Error fetching plan options:', error);
    })
    .finally(() => {
      setPlanLoading(false);
    });


    setPlanOptionLoading(true)
    axios.post(GET_PLANOPTIONS, {
      token: localStorage.getItem('token'),
      getPlanOptions: true,
      builderId: builderId,

    })
    .then((response) => {
      const options = response.data?.message?.planOptions || [];

      // Filter out archived ones
      const activeOptions = options.filter(opt => !opt.archived);

      // Sort alphanumerically
      const sortedPlanOptions = activeOptions.sort((a, b) =>
        a.planOptionName.localeCompare(b.planOptionName, undefined, {
          numeric: true,
          sensitivity: 'base',
        })
      );

      setPlanOptions(sortedPlanOptions);
    })
    .catch((error) => {
      console.error('Error fetching plan options:', error);
    })
    .finally(() => {
      setPlanOptionLoading(false);
    });


    setelevationLoading(true)
    axios.post(GET_ELEVATIONS, {
      token: localStorage.getItem('token'),
      getElevations: true,
      builderId: builderId,
    })
    .then((response) => {
      const elevationList = response.data?.message?.elevations || [];
      const sorted = elevationList.sort((a, b) =>
        a.elevationName.localeCompare(b.elevationName, undefined, { numeric: true, sensitivity: 'base' })
      );
      setElevations(sorted);
    })
    .catch((error) => {
      console.error('Error fetching elevations:', error);
    })    
    .finally(() => {
      setelevationLoading(false);
    });
  }, [formValues.builder?.id]);

  const [newFile, setNewFile] = useState(null);
  const [newPdfFile, setNewPdfFile] = useState(null);

  const handlePdfFile = (file) => {

    const isValidSize = file.size <= 10485760;
    if (!isValidSize) {
      setErrors((prev) => ({
        ...prev,
        pdfFile: 'PDF file must be 10MB or less',
      }));
      return;
    } else {
      setErrors((prev) => ({ ...prev, pdfFile: '' }));
    }

    setPdfUploadStatus('loading');

    const modifiedDate = new Date(file.lastModified).toISOString();

    axios
      .post(SAVE_PDF_FILE, {
        token: localStorage.getItem('token'),
        savePDF: true,
        fileName: file.name,
        modifiedDate: modifiedDate,
      })
      .then((response) => {
        const savedFile = response.data?.body?.message?.pdfFile;
        console.log("Response from SAVE_PDF_FILE:", response);
        if (savedFile) {
          setNewPdfFile({
            file,
            savedFileId: savedFile.id,
            name: savedFile.fileName,
            savedFileUploadedBy: savedFile.uploadedBy,
            savedFileUploadedDate: savedFile.uploadedDateAndTime,
            savedFileModifiedDate: file.lastModifiedDate
          });
          setPdfUploadStatus('success');
        } else {
          console.error('Unexpected response format:', response);
          setPdfUploadStatus('error');
          setErrors((prev) => ({ ...prev, pdfFile: 'Failed to save file info' }));
        }
      })
      .catch((error) => {
        console.error('Error saving PDF file:', error);
        setPdfUploadStatus('error');
        setPdfUploadError('Error uploading file');
        setErrors((prev) => ({ ...prev, pdfFile: 'Error uploading file' }));
      });
  };

  const handleFile = (file) => {

    const isValidSize = file.size <= 5242880;
    if (!isValidSize) {
      setUploadStatus('error');
      setErrors((prev) => ({
        ...prev,
        file: 'File must be 5MB or less',
      }));
      return;
    } else {
      setUploadStatus('success');
      setUploadError('');
      setErrors((prev) => ({ ...prev, file: '' }));
    }

    const modifiedDate = new Date(file.lastModified).toISOString();
    setUploadLoading(true);

    axios
      .post(SAVE_FILE, {
        token: localStorage.getItem('token'),
        saveFile: true,
        fileName: file.name,
        modifiedDate: modifiedDate,
      })
      .then((response) => {
        const savedFile = response.data?.body?.message?.cadFile;
        if (savedFile) {
          setNewFile(({
            file,
            savedFileId: savedFile.id,
            name: savedFile.fileName,
            savedFileUploadedBy: savedFile.uploadedBy,
            savedFileUploadedDate: savedFile.uploadedDateAndTime,
            savedFileModifiedDate: file.lastModifiedDate
          }));
          setUploadStatus('success');
          setErrors((prev) => ({ ...prev, file: '' }));
        } else {
          console.error('Unexpected response format:', response);
          setUploadStatus('error');
          setErrors((prev) => ({ ...prev, file: 'Failed to save file info' }));
        }
      })
      .catch((error) => {
        console.error('Error saving file:', error);
        setUploadStatus('error');
        setErrors((prev) => ({ ...prev, file: 'Error uploading file' }));
      })
      .finally(() => {
        setUploadLoading(false);
      });

    handleChange('file', file);
  };

  const handleChange = (field, value) => {
    const updated = { ...formValues, [field]: value };
    setFormValues(updated);
  };

  useEffect(()=> {
    if (openModal && selectedBuilderId && builders.length) {
      const b = builders.find(x => x.id === selectedBuilderId);
      if (b) {
        console.log(b)
        setValue(b);
        setFormValues((prev) => ({
          ...prev,
          builder: b,
          lotLocation: "",
          layout: "",
          planNotes: ""
        }));

        setPlanOptionValue([]);
      }
    }
  }, [openModal])

  const handleSave = async () => {
    try {

      setUploadStatus('loading');

      const newErrors = {};

      // Validate file
      if (!newFile) {
        newErrors.file = 'You must add a DWG file';
      } else {
        const isDWG = newFile.file.name.toLowerCase().endsWith('.dwg');
        const isMax100KB = newFile.file.size <= 5242880; // 5mb

        if (!isDWG) {
          newErrors.file = 'Only .dwg files are allowed';
        } else if (!isMax100KB) {
          newErrors.file = 'File must be 5MB or less';
        }
      }

      // Validate builder
      if (!formValues.builder) {
        newErrors.builder = 'Builder is required';
      }

      // Validate plan number
      if (!formValues.planNumber) {
        newErrors.planNumber = 'Plan # is required';
      }

      if (formValues.nonStandard && !formValues.anchorNotes?.trim()) {
        newErrors.anchorNotes = 'Anchor placement notes are required';
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setShowValidationAlert(true);

        // Scroll to the alert after state updates
        setTimeout(() => {
          alertRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);

        return;
      }

      setSaveLoading(true)
      console.log("formValues before saving:", formValues);

      const planResponse = await axios.post(CREATE_PLAN, {
        token: localStorage.getItem('token'),
        createPlan: true,
        planNumberId: formValues.planNumber.id,
        builderId: formValues.builder?.id,
        cadFileId: newFile.savedFileId,
        pdfFileId: newPdfFile?.savedFileId || "",
        projectId: formValues.projectId || "",
        elevationId: formValues.elevationId,
        planOptionIds: selectedPlanOptions,
        buildStageIds: selectedBuildStages,
        lot_Name: formValues.lotLocation || "",
        layout: ['Left', 'Right'].includes(formValues.layout) ? formValues.layout : "",
        plan_Note: formValues.planNotes || "",
        nonstandard_Anchor: formValues.nonStandard || false,
        anchor_Note: formValues.nonStandard ? (formValues.anchorNotes || "") : undefined,
      });

      console.log("Raw response:", planResponse);
      if(planResponse?.data?.code === 0){

        const planId = planResponse?.data?.message?.plan?.id;
        formValues.planId = planId

        // upload the file using planId as the filename
        if (!newFile) {
          setUploadStatus('error');
          setUploadError('Please select a file before saving.');
          return;
        }

        console.log("Uploading with cadFileId:", newFile.savedFileId);

          // saving in azure files like: orgId -> builderId -> cadFileid
          await axios.post(UPLOAD_DWG_FILE, {
            token: localStorage.getItem('token'),
            orgId: localStorage.getItem('orgId'),
            builderId: formValues.builder?.id,
            cadFile: newFile.file,
            cadFileId: newFile.savedFileId
          }, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });

          // upload PDF to Azure
          if (newPdfFile) {
            await axios.post(UPLOAD_PDF_FILE, {
              token: localStorage.getItem('token'),
              pdfFile: newPdfFile.file,
              pdfId: newPdfFile.savedFileId
            }, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });
          }

        const planOptionsForLists = planOptions.filter(o =>
          selectedPlanOptions.includes(o.id)
        );

        const buildStagesForLists = buildStages.filter(b =>
          selectedBuildStages.includes(b.id)
        );

        setSelectedBuilderId(formValues.builder?.id)

        await addNewPlanToBuildersList(formValues, newFile, planOptionsForLists, buildStagesForLists, newPdfFile);

        setHighlightPlanId(planId);

        handleDiscardForm();
        setUploadStatus('success');
        setUploadError('');
        setSaveLoading(false)
        closeModal();
      }
    } catch (error) {
      console.error("Error during save:", error);
    }
  };

  async function saveAndAddNew() {
    await handleSave()
    setTimeout(()=> setOpenModal(true), 1000)
  }

  // useEffect(()=>{
  //   console.log(formValues)
  // }, [formValues])

  const handleDeleteFile = () => {
    setNewFile(null);
    setUploadStatus(null);
    setUploadError('');
  };

  const closeModal = () => {
    if (drawerScrollRef.current) {
      drawerScrollRef.current.scrollTop = 0;
    }
    setOpenModal(false);
    setConfirmCloseDialog(false);
    setShowValidationAlert(false);
  };

  const handleAttemptClose = () => {
    const hasChanges = Object.keys(formValues).some(key => {
      const currentValue = formValues[key];
      const initialValue = initialFormValues[key];
      
      if (Array.isArray(currentValue) && Array.isArray(initialValue)) {
        return currentValue.length !== initialValue.length;
      }
      
      return currentValue !== initialValue;
    });
    
    if (hasChanges) {
      setConfirmCloseDialog(true);
      return true;
    } else {
      discardAndClose();
      return false;
    }
  };

  const handleDiscardForm = () => {
    setFormValues(initialFormValues);
    setNewFile(null);
    setNewPdfFile(null);

    setPlanOptionValue([]);
    setBuildStageValue([]);
    setProjectValue(null);
    setValue(null);
    setErrors({});
  };

  const discardAndClose = () => {
    if (drawerScrollRef.current) {
      drawerScrollRef.current.scrollTop = 0;
    }
    handleDiscardForm();
    setShowValidationAlert(false);
    setConfirmCloseDialog(false);
    setOpenModal(false);
  };

  const drawerScrollRef = useRef(null);

  // for the blue border hovering the element values using arrow keys
  const layoutListboxRef = useRef(null);
  const buildStageListboxRef = useRef(null);
  const builderListboxRef = useRef(null);
  const projectListboxRef = useRef(null);
  const planListboxRef = useRef(null);
  const elevationListboxRef = useRef(null);
  const planOptionsListboxRef = useRef(null);

  return (
    <>
      <Drawer
        anchor="right"
        open={openModal}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            const blocked = handleAttemptClose();

            if (blocked) {
              return;
            }

            discardAndClose();
          }
        }}
        ModalProps={{
          keepMounted: true,
        }}
        data-testid="plan-info-drawer"
      >
        <Box
          sx={{
            width: "670px",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: "background.paper",
              px: 3,
              py: 2,
              borderBottom: "1px solid #eee",
            }}
          >
            <IconButton
              onClick={handleAttemptClose}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" sx={{ m: 0, lineHeight: 1.2 }}>
              Plan Info
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ m: 0, mt: "4px", lineHeight: 1.4 }}
            >
              Upload a CAD file and a plan PDF, then fill out the details below to add your plan.
            </Typography>
          </Box>

          {/* Scrollable Drawer Body */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              px: 3,
              py: 2,
            }}
            ref={drawerScrollRef}
          >
            {/* Validation Alert */}
            {showValidationAlert && (
              <Alert
                data-testid="alert-error"
                ref={alertRef}
                severity="error"
                sx={{
                  backgroundColor: "#fdecea",
                  color: "#611a15",
                  borderRadius: 1,
                  fontSize: "14px",
                  padding: "16px",
                  marginBottom: "24px",
                  width: "100%",
                }}
              >
                <strong>Missing required information</strong>
                <br />
                Please fill in the required missing information as noted.
              </Alert>
            )}

            <CardContent sx={{ ml: "8px" }}>              
              {/* Upload Box */}
              <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: "8px" }} color={"text.secondary"}>
                <ArchitectureOutlinedIcon />
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>CAD File</Typography>
              </Stack>
              <Box
                onDrop={(e) => {
                  e.preventDefault();
                  if (newFile) return;

                  const file = e.dataTransfer.files?.[0];
                  if (!file) return;

                  if (!file.name.toLowerCase().endsWith(".dwg")) {
                    setErrors((prev) => ({
                      ...prev,
                      file: "Unsupported file. You can only upload a .DWG",
                    }));
                    return;
                  }

                  handleFile(file);
                }}
                onDragOver={(e) => e.preventDefault()}
                onDragLeave={(e) => e.preventDefault()}
                sx={{
                  border: !newFile ? "2px dashed" : "none",
                  borderColor: errors.file ? "error.main" : "divider",
                  borderRadius: "2px",
                  textAlign: "center",
                  minHeight: "150px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  position: "relative",
                  width: "552px",
                }}
                data-testid="file-upload-area"
              >
                {!newFile ? (
                  <>
                    <Button
                      component="label"
                      startIcon={null}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textTransform: "none",
                        variant: "text",
                        color: "inherit",
                        p: 4,
                        border: "1px dashed #ccc",
                        borderRadius: 2,
                        width: "100%",
                        cursor: "pointer",
                        textAlign: "center",
                      }}
                      data-testid="file-upload-button"
                    >
                      <UploadFileIcon
                        sx={{ fontSize: 40, mb: 1, color: "#1976d2" }}
                        data-testid="upload-icon"
                      />
                      <Typography data-testid="upload-text">
                        <span style={{ color: "#1976d2", fontWeight: 500 }}>
                          Link
                        </span>
                        <span style={{ color: "#000" }}>
                          {" "}
                          or drag and drop to add or replace a file
                        </span>
                      </Typography>
                      <Typography
                        sx={{ color: "#00000099", mt: 0.5 }}
                        data-testid="dwg-text"
                      >
                        DWG (max. 5MB)
                      </Typography>
                      <input
                        type="file"
                        hidden
                        accept=".dwg"
                        onChange={(e) => {
                          if (newFile?.file) return;

                          const file = e.target.files[0];
                          if (!file) return;

                          if (!file.name.toLowerCase().endsWith(".dwg")) {
                            setErrors((prev) => ({
                              ...prev,
                              file: "Unsupported file. You can only upload a .DWG",
                            }));
                            return;
                          }

                          handleFile(file);
                        }}
                        data-testid="file-input"
                      />
                    </Button>
                  </>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "520px",
                      height: "80px",
                      padding: "16px",
                      marginLeft: "24px",
                      marginRight: "24px",
                      border: '1px solid lightgray',
                      textAlign: "left",
                    }}
                    data-testid="file-preview"
                  >
                    <Box display="flex" alignItems="center">
                      <UploadFileIcon
                        color={uploadStatus === "error" ? "error" : "success"}
                        sx={{ mr: 1 }}
                        data-testid="upload-icon"
                      />
                      <Box>
                        <Typography variant="body2" data-testid="file-name">
                          {newFile.file.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          <span data-testid="file-size">
                            {Math.round(newFile.file.size / 1024)}kb • {uploadStatus === "error" ? "Failed" : "Complete"}
                          </span>
                        </Typography>
                        {uploadStatus === "error" && (
                          <Typography
                            variant="caption"
                            color="error"
                            display="block"
                          >
                            {uploadError}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center">
                      <IconButton
                        onClick={handleDeleteFile}
                        data-testid="delete-file-button"
                      >
                        <DeleteIcon fontSize="small" data-testid="delete-icon" />
                      </IconButton>
                      {/* {uploadStatus === 'success' && (
                      <CheckCircleIcon color="success" fontSize="small" sx={{ ml: 1 }} />
                    )} */}
                    </Box>
                  </Box>
                )}
              </Box>

                {errors.file && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ mb: 1, display: "block" }}
                  >
                    {errors.file}
                  </Typography>
                )}

              {/* PDF Upload Box */}
              <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2 }} color={"text.secondary"}>
                <DescriptionOutlinedIcon />
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>Plan PDF</Typography>
              </Stack>
              <Box
                onDrop={(e) => {
                  e.preventDefault();
                  if (newPdfFile) return;

                  const file = e.dataTransfer.files?.[0];
                  if (!file) return;

                  if (!file.name.toLowerCase().endsWith(".pdf")) {
                    setErrors((prev) => ({
                      ...prev,
                      pdfFile: "Unsupported file. You can only upload a .PDF",
                    }));
                    return;
                  }

                  handlePdfFile(file);
                }}
                onDragOver={(e) => e.preventDefault()}
                onDragLeave={(e) => e.preventDefault()}
                sx={{
                  border: !newPdfFile ? "2px dashed" : "none",
                  borderColor: errors.pdfFile ? "error.main" : "divider",
                  borderRadius: "2px",
                  textAlign: !newPdfFile ? "center" : "left",
                  mb: "2px",
                  mt: 2,
                  minHeight: "150px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  position: "relative",
                  width: "552px",
                }}
                data-testid="pdf-upload-area"
              >
                {!newPdfFile ? (
                  <>
                    <Button
                      component="label"
                      startIcon={null}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textTransform: "none",
                        variant: "text",
                        color: "inherit",
                        p: 4,
                        border: "1px dashed #ccc",
                        borderRadius: 2,
                        width: "100%",
                        cursor: "pointer",
                        textAlign: "center",
                      }}
                      data-testid="pdf-upload-button"
                    >
                      <UploadFileIcon
                        sx={{ fontSize: 40, mb: 1, color: "#1976d2" }}
                        data-testid="pdf-upload-icon"
                      />
                      <Typography data-testid="pdf-upload-text">
                        <span style={{ color: "#1976d2", fontWeight: 500 }}>
                          Link
                        </span>
                        <span style={{ color: "#000" }}>
                          {" "}
                          or drag and drop to add a PDF plan sheet
                        </span>
                      </Typography>
                      <Typography
                        sx={{ color: "#00000099", mt: 0.5 }}
                        data-testid="pdf-text"
                      >
                        PDF (max. 10MB)
                      </Typography>
                      <input
                        type="file"
                        hidden
                        accept=".pdf"
                        onChange={(e) => {
                          if (newPdfFile?.file) return;

                          const file = e.target.files[0];
                          if (!file) return;

                          if (!file.name.toLowerCase().endsWith(".pdf")) {
                            setErrors((prev) => ({
                              ...prev,
                              pdfFile: "Unsupported file. You can only upload a .PDF",
                            }));
                            return;
                          }

                          handlePdfFile(file);
                        }}
                        data-testid="pdf-file-input"
                      />
                    </Button>
                  </>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "520px",
                      height: "80px",
                      padding: "16px",
                      marginLeft: "24px",
                      marginRight: "24px",
                      border: "1px solid lightgray",
                      textAlign: "left",
                    }}
                    data-testid="pdf-file-preview"
                  >
                    <Box display="flex" alignItems="center">
                      <UploadFileIcon
                        color={pdfUploadStatus === 'error' ? 'error' : 'success'}
                        sx={{ mr: 1 }}
                        data-testid="pdf-preview-icon"
                      />
                      <Box>
                        <Typography variant="body2" data-testid="pdf-file-name" sx={{ textAlign: "left" }}>
                          {newPdfFile.file.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ textAlign: "left" }}>
                          <span data-testid="pdf-file-size">
                            {(newPdfFile.file.size / 1024) >= 1024 ? `${(newPdfFile.file.size / 1048576).toFixed(1)} MB` : `${Math.round(newPdfFile.file.size / 1024)} KB`} • {pdfUploadStatus === 'error' ? ' Failed' : ' Complete'}
                          </span>
                        </Typography>
                        {pdfUploadStatus === 'error' && (
                          <Typography variant="caption" color="error" display="block">
                            {pdfUploadError}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center">
                      <IconButton
                        onClick={() => {
                          setNewPdfFile(null);
                          setPdfUploadStatus('');
                          setPdfUploadError('');
                          setErrors((prev) => ({ ...prev, pdfFile: '' }));
                        }}
                        data-testid="delete-pdf-button"
                      >
                        <DeleteIcon fontSize="small" data-testid="pdf-delete-icon" />
                      </IconButton>
                    </Box>
                  </Box>
                )}
              </Box>

              {errors.pdfFile && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mb: 1, display: "block" }}
                >
                  {errors.pdfFile}
                </Typography>
              )}


              <FormControlLabel
                sx={{ mt: marginTopBetweenFields, ml: 2 }}
                control={
                  <Switch
                    checked={formValues.nonStandard}
                    onChange={(e) => {
                      handleChange("nonStandard", e.target.checked)
                      if(e.target.checked){
                        setTimeout(() => {
                          anchorPlacementInputRef.current?.focus();
                        }, 100);
                      }
                    }}
                    // disabled={!formValues.builder}
                  />
                }
                label="Non-standard Anchor Placement (Optional)"
              />

              {formValues.nonStandard ? (
                <Box sx={{ mt: marginTopBetweenFields, ml: 3 }}>
                  <Box display="flex" alignItems="center">
                    <TextField
                      sx={{ width: secondaryFieldWidth }}
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <CenterFocusWeakIcon sx={{ color: red[500] }}/>
                            </InputAdornment>
                          ),
                        },
                      }}
                      data-testid="anchor-placement-input"
                      inputRef={anchorPlacementInputRef}
                      fullWidth
                      id="input-with-sx"
                      label="Non-standard Anchor Placement Notes"
                      variant="standard"
                      inputProps={{ maxLength: 500 }}
                      value={formValues.anchorNotes}
                      onChange={(e) =>
                        handleChange("anchorNotes", e.target.value)
                      }
                      error={!!errors.anchorNotes}
                      helperText={errors.anchorNotes}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          buildStageInputRef.current?.focus();
                        }
                      }}
                      onBlur={() => {
                        buildStageInputRef.current?.focus();
                      }}
                    />
                  </Box>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                  >
                    Help crews know where to place anchor images. 
                  </Typography>
                </Box>
              ) : (
                <Box display="flex" alignItems="center" sx={{ mt: marginTopBetweenFields, ml: 3 }}>
                  <CenterFocusStrongIcon sx={{ color: green[500], mr: 1 }} />
        
                  <Box>
                    <Box display="flex" alignItems="center">
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 0.5 }}>
                          Standard Anchor Placement
                        </Typography>
                        <Typography variant="body2">
                          {formValues?.nonStandard
                            ? formValues.anchorNotes || 'No anchor note provided.'
                            : orgSettings?.standard_anchor_placement || 'Standard placement not defined'}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                    >
                      (Admins can adjust this standard in Settings)
                    </Typography>
                  </Box>
                </Box>
              )}


              <Autocomplete
                sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}
                value={buildStageValue}
                autoHighlight
                openOnFocus
                id="build-stage-autocomplete"
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => buildStageListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: buildStageListboxRef,
                  onMouseMove: () => buildStageListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                options={buildStages}
                isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false;
                    if (option.id && value.id) return option.id === value.id;
                    return (
                      (option.buildStageName || "").trim().toLowerCase() ===
                      (value.buildStageName || "").trim().toLowerCase()
                    );
                  }}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;
                  if (option.inputValue) return option.inputValue;
                  return option?.buildStageName || "";
                }}
                filterOptions={(options, params) => {
                  const filtered = options.filter((option) =>
                    option.buildStageName.toLowerCase().includes(params.inputValue.toLowerCase())
                  );

                  return filtered;
                }}
                onChange={(event, newValue) => {
                  setBuildStageValue(newValue);

                  setSelectedBuildStages(newValue ? [newValue.id] : []);

                  setFormValues((prev) => ({
                    ...prev,
                    buildStage: newValue
                  }));

                  setTimeout(() => {
                    buildStageInputRef.current?.blur();
                    builderInputRef.current?.focus();
                  }, 100);
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}
                      data-testid={`build-stage-option-${option.id}`}
                    >
                      {option.buildStageName}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Build Stage (Optional)"
                    inputRef={buildStageInputRef}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {buildStageLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {buildStageValue ? params.InputProps.endAdornment : null}
                        </>
                      ),
                    }}
                  />
                )}
              />


              <Autocomplete
                sx={{ mt: marginTopBetweenFields, width: mainFieldWidth }}
                value={value}
                autoHighlight
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => builderListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: builderListboxRef,
                  onMouseMove: () => builderListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                onChange={(event, newValue) => {
                  const input =
                    typeof newValue === "string"
                      ? newValue
                      : newValue?.inputValue;

                  // Case 1: typed input
                  if (
                    typeof newValue === "string" ||
                    (newValue && newValue.inputValue)
                  ) {
                    const trimmedInput = input?.trim().toLowerCase();
                    const exists = builders.some(
                      (b) => b.builderName.trim().toLowerCase() === trimmedInput
                    );

                    if (exists) {
                      // Select existing builder
                      const existingBuilder = builders.find(
                        (b) => b.builderName.trim().toLowerCase() === trimmedInput
                      );
                      setValue(existingBuilder);
                      setFormValues((prev) => ({
                        ...prev,
                        builder: existingBuilder,
                        lotLocation: "",
                        layout: "",
                        planNotes: ""
                      }));

                      setPlanOptionValue([]);

                      setErrors((prev) => ({ ...prev, builder: "" }));

                      setTimeout(() => {
                        builderInputRef.current?.blur();
                        projectInputRef.current?.focus();
                      }, 100);
                    } else if (input) {
                      // Create new builder
                      console.log("Creating new builder: " + input);
                      setBuilderLoading(true);

                      axios
                        .post(GET_BUILDERS, {
                          token: localStorage.getItem("token"),
                          createBuilder: "true",
                          builderName: input,
                        })
                        .then((response) => {

                          const newBuilder = response.data?.message?.builder;

                          if(response.data.code == 223){
                            let existingId = response.data.existingBuilderId

                              axios.post(GET_BUILDERS, {
                                  token: localStorage.getItem('token'),
                                  archiveBuilder: true,
                                  archive: false,
                                  id: existingId
                              })
                              .then((response) => {

                                const builder = {
                                  builderName: input,
                                  id: existingId,
                                  orgId: localStorage.getItem("orgId")
                                }
                                
                                setBuilders((prev) => [...prev, builder]);
                                setValue(builder);
                                setFormValues((prev) => ({
                                  ...prev,
                                  builder: builder,
                                  lotLocation: "",
                                  layout: "",
                                  planNotes: ""
                                }));
                                setErrors((prev) => ({ ...prev, builder: "" }));

                                setPlanOptionValue([]);

                                setTimeout(() => {
                                  console.log(
                                    "Blurring builder and focusing project (new)"
                                  );
                                  builderInputRef.current?.blur();
                                  projectInputRef.current?.focus();
                                }, 100);

                              })
                              .catch((error) => {
                                  console.error('Error updating builder archive status:', error);
                              });

                          } else {

                            setBuilders((prev) => [...prev, newBuilder]);
                            setValue(newBuilder);
                            setFormValues((prev) => ({
                              ...prev,
                              builder: newBuilder,
                              lotLocation: "",
                              layout: "",
                              planNotes: ""
                            }));
                            setErrors((prev) => ({ ...prev, builder: "" }));

                            setPlanOptionValue([]);

                            setTimeout(() => {
                              console.log(
                                "Blurring builder and focusing project (new)"
                              );
                              builderInputRef.current?.blur();
                              projectInputRef.current?.focus();
                            }, 100);

                          }
                        })
                        .catch((error) => {
                          console.error("Error creating builder:", error);
                        })
                        .finally(() => {
                          setBuilderLoading(false);
                        });
                    }
                  } else {
                    // Case 2: existing builder selected from dropdown
                    setValue(newValue);
                    setFormValues((prev) => ({
                      ...prev,
                      builder: newValue,
                      lotLocation: "",
                      layout: "",
                      planNotes: ""
                    }));
                    if (newValue?.builderName) {
                      setErrors((prev) => ({ ...prev, builder: "" }));
                    }

                    setPlanOptionValue([]);

                    setTimeout(() => {
                      builderInputRef.current?.blur();
                      projectInputRef.current?.focus();
                    }, 100);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = options.filter((option) =>
                    option.builderName
                      .toLowerCase()
                      .includes(params.inputValue.toLowerCase())
                  );
                  const isExisting = options.some(
                    (option) =>
                      option.builderName.toLowerCase() ===
                      params.inputValue.toLowerCase()
                  );

                  if (params.inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue: params.inputValue,
                      builderName: `Add "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                id="builder-autocomplete"
                options={builders}
                getOptionLabel={(option) => {
                  if (typeof option === "string") {
                    return option;
                  }
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  return option.builderName;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const isAddOption = !!option.inputValue;

                  return (
                    <li key={key} {...optionProps}>
                      <span
                        style={{ color: isAddOption ? "#1976d2" : "inherit" }}
                      >
                        {option.builderName}
                      </span>
                    </li>
                  );
                }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    data-testid="builder-autocomplete-input"
                    {...params}
                    inputRef={builderInputRef}
                    variant="standard"
                    label="Builder Name"
                    error={Boolean(errors.builder)}
                    helperText={errors.builder}
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 50,
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {builderLoading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />

              <Autocomplete
                sx={{
                  mt: marginTopBetweenFields,
                  ml: 3,
                  width: secondaryFieldWidth,
                  "& .MuiAutocomplete-option.Mui-focused": {
                    backgroundColor: "#1976d2",
                    color: "#fff",
                  },
                  "& .MuiAutocomplete-option[aria-selected='true']": {
                    backgroundColor: "#1976d2",
                    color: "#fff",
                  },
                }}
                disabled={!formValues.builder}
                value={projectValue}
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => projectListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: projectListboxRef,
                  onMouseMove: () => projectListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                open={projectOpen}
                inputValue={projectInputValue} // 👈 control input text
                onInputChange={(e, newInputValue) =>
                  setProjectInputValue(newInputValue)
                }
                onOpen={() => setProjectOpen(true)}
                onClose={() => setProjectOpen(false)}
                autoHighlight
                openOnFocus
                onChange={(event, newValue) => {
                  const input =
                    typeof newValue === "string"
                      ? newValue
                      : newValue?.inputValue;

                  const builderId = formValues.builder?.id;

                  if (!builderId) {
                    console.warn("No builder ID found; skipping project fetch.");
                    return;
                  }

                  if (
                    typeof newValue === "string" ||
                    (newValue && newValue.inputValue)
                  ) {
                    const trimmedInput = input?.trim().toLowerCase();
                    const exists = projects.some(
                      (p) => p.projectName.trim().toLowerCase() === trimmedInput
                    );

                    if (exists) {
                      const existingProject = projects.find(
                        (p) => p.projectName.trim().toLowerCase() === trimmedInput
                      );
                      setProjectValue(existingProject);
                      setFormValues((prev) => ({
                        ...prev,
                        project: existingProject.projectName,
                        projectId: existingProject?.id || ""
                      }));
                      setTimeout(() => {
                        projectInputRef.current?.blur();
                        lotLocationInputRef.current?.focus();
                      }, 100);
                    } else if (input) {
                      // New project, create it
                      setProjectLoading(true);

                      axios
                        .post(GET_PROJECTS, {
                          token: localStorage.getItem("token"),
                          addProject: "true",
                          builderId,
                          projectName: input,
                        })
                        .then((response) => {
                          const newProject = response.data?.message?.project;

                          if(response.data.code == 224){
                            let existingId = response.data.existingProjectId

                              axios.post(GET_PROJECTS, {
                                  token: localStorage.getItem('token'),
                                  builderId: builderId,
                                  archiveProject: true,
                                  archive: false,
                                  id: existingId
                              })
                              .then((response) => {

                                const newProject = {
                                  projectName: input,
                                  id: existingId,
                                  orgId: localStorage.getItem("orgId")
                                }
                                
                                setProjects((prev) => {
                                  const exists = prev.some(
                                    (p) =>
                                      p.projectName.trim().toLowerCase() ===
                                      newProject.projectName.trim().toLowerCase()
                                  );
                                  if (!exists) {
                                    return [...prev, newProject];
                                  }
                                  return prev;
                                });

                                setProjectValue(newProject);
                                setFormValues((prev) => ({
                                  ...prev,
                                  project: newProject.projectName,
                                  projectId: newProject.id
                                }));

                                setTimeout(() => {
                                  projectInputRef.current?.blur();
                                  lotLocationInputRef.current?.focus();
                                }, 100);

                              })
                              .catch((error) => {
                                  console.error('Error updating builder archive status:', error);
                              });

                          } else {

                            setProjects((prev) => {
                              const exists = prev.some(
                                (p) =>
                                  p.projectName.trim().toLowerCase() ===
                                  newProject.projectName.trim().toLowerCase()
                              );
                              if (!exists) {
                                return [...prev, newProject];
                              }
                              return prev;
                            });

                            setProjectValue(newProject);
                            setFormValues((prev) => ({
                              ...prev,
                              project: newProject.projectName,
                              projectId: newProject.id
                            }));
                            
                            setTimeout(() => {
                              projectInputRef.current?.blur();
                              lotLocationInputRef.current?.focus();
                            }, 100);
                          }
                        })
                        .catch((error) => {
                          console.error("Error creating project:", error);
                        })
                        .finally(() => {
                          setProjectLoading(false);
                        });
                    }
                  } else {
                    // Selected from dropdown
                    setProjectValue(newValue);
                    setFormValues((prev) => ({
                      ...prev,
                      project: newValue?.projectName || "",
                      projectId: newValue?.id || "",
                    }));
                    // 👉 Focus plan number field
                    setTimeout(() => {
                      lotLocationInputRef.current?.focus();
                    }, 100);
                  }
                }}
                filterOptions={(options, params) => {
                  const inputValue = params.inputValue.trim().toLowerCase();
                  if (!inputValue) return options;

                  const filtered = options.filter((option) =>
                    option.projectName
                      .toLowerCase()
                      .includes(params.inputValue.toLowerCase())
                  );

                  const exactMatch = options.some(
                    (option) =>
                      option.projectName.trim().toLowerCase() === inputValue
                  );

                  if (params.inputValue !== "" && !exactMatch) {
                    filtered.push({
                      inputValue: params.inputValue,
                      projectName: `Add "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                id="project-autocomplete"
                options={projects}
                getOptionLabel={(option) => {
                  if (typeof option === "string") {
                    return option;
                  }
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  return option.projectName;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const isAddOption = !!option.inputValue;

                  return (
                    <li key={key} {...optionProps}>
                      <span
                        style={{ color: isAddOption ? "#1976d2" : "inherit" }}
                      >
                        {option.projectName}
                      </span>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    data-testid="project-autocomplete-input"
                    {...params}
                    inputRef={projectInputRef}
                    onFocus={() => {
                      if (projects.length > 0) {
                        setProjectOpen(true);
                      }
                    }}
                    onBlur={() => {
                      setProjectOpen(false);
                    }}
                    variant="standard"
                    label="Project Name (Optional)"
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 50,
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {projectLoading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />

              
              <Box sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}>
                <Box display="flex" alignItems="center">
                  <TextField
                    disabled={!formValues.builder} // Disable until builder is selected
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <RoomIcon/>
                          </InputAdornment>
                        ),
                      },
                    }}
                    data-testid="lot-location-input"
                    id="input-with-sx"
                    label="Lot Location"
                    variant="standard"
                    inputRef={lotLocationInputRef}
                    fullWidth
                    value={formValues.lotLocation}
                    onChange={(e) =>
                      handleChange("lotLocation", e.target.value)
                    }
                    error={!!errors.lotLocation}
                    helperText={errors.lotLocation}
                    inputProps={{ maxLength: 5 }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        planInputRef.current?.focus();
                      }
                    }}
                  />
                </Box>
                <Typography
                  variant="caption"
                  color="textSecondary"
                >
                  Where is the lot located? (Lot number, address, etc.)
                </Typography>
              </Box>


              <Autocomplete
                sx={{ mt: marginTopBetweenFields, width: mainFieldWidth }}
                disabled={!formValues.builder}
                value={formValues.planNumber}
                autoHighlight
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => planListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: planListboxRef,
                  onMouseMove: () => planListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                openOnFocus
                onChange={(event, newValue) => {
                  const input = (typeof newValue === 'string' ? newValue : newValue?.inputValue) || '';
                  const builderId = formValues?.builder?.id;

                  if (!builderId) {
                    console.error("Cannot add plan: builder ID is missing.");
                    return;
                  }

                  if (newValue === null) {
                    // User clicked X → just clear the selected plan number
                    setFormValues((prev) => ({ ...prev, planNumber: null }));
                    return;
                  }

                  if (typeof newValue === 'string' || (newValue && newValue.inputValue)) {
                    const trimmedInput = input.trim().toLowerCase();
                    const exists = planNumbers.some(
                      (p) => (p?.planNumberName || '').trim().toLowerCase() === trimmedInput
                    );

                    if (exists) {
                      const existingPlan = planNumbers.find(
                        (p) => (p?.planNumberName || '').trim().toLowerCase() === trimmedInput
                      );
                      
                      setFormValues((prev) => ({
                        ...prev,
                        planNumber: existingPlan,
                      }));
                      setErrors((prev) => ({ ...prev, planNumber: '' }));

                      setTimeout(() => { elevationInputRef.current?.focus(); }, 100);

                    } else if (input) {

                      setPlanLoading(true);

                      axios.post(GET_PLANNUMBERS, {
                        token: localStorage.getItem('token'),
                        createPlanNumber: true,
                        planNumberName: input,
                        builderId: builderId
                      })
                        .then((response) => {
                          const newPlan = response.data?.message?.plannumber;

                          if(response.data.code === 225){ // unarchive, if exists
                            let existingId = response.data.existingPlanNumberId
                            axios.post(GET_PLANNUMBERS, {
                                token: localStorage.getItem('token'),
                                archivePlanNumber: true,
                                archive: false,
                                id: existingId,
                                builderId: builderId
                            })
                            .then((response) => {
                              
                              setPlanNumbers((prev) => [
                                ...prev,
                                {
                                  planNumberName: input,
                                  id: existingId,
                                  orgId: localStorage.getItem("orgId"),
                                },
                              ]);

                              setFormValues((prev) => ({
                                ...prev,
                                planNumber: {
                                  planNumberName: input,
                                  id: existingId,
                                  orgId: localStorage.getItem("orgId"),
                                },
                              }));

                              setTimeout(() => { elevationInputRef.current?.focus(); }, 100);

                            })
                            .catch((error) => {
                                console.error('Error updating builder archive status:', error);
                            });

                          } else{ // add if not exists

                            if (!newPlan || !newPlan.planNumberName) {
                              console.error("Invalid plan format from server:", response.data);
                              return;
                            }
                              
                            setPlanNumbers((prev) => {
                              const exists = prev.some(
                                (p) =>
                                  p?.planNumberName?.trim().toLowerCase() ===
                                  newPlan.planNumberName.trim().toLowerCase()
                              );
                              return exists ? prev : [...prev, newPlan];
                            });

                            
                            setFormValues((prev) => ({
                              ...prev,
                              planNumber: newPlan,
                            }));
                            setErrors((prev) => ({ ...prev, planNumber: '' }));

                            setTimeout(() => { elevationInputRef.current?.focus(); }, 100);
                          }

                        })
                        .catch((error) => {
                          console.error('Error creating plan number:', error);
                        })
                        .finally(() => {
                          setPlanLoading(false);
                        });
                    }
                  } else {
                    // Existing plan selected from dropdown
                    
                    setFormValues((prev) => ({
                      ...prev,
                      planNumber: newValue,
                    }));

                    if (newValue?.planNumberName) {
                      setErrors((prev) => ({ ...prev, planNumber: '' }));
                    }

                    setTimeout(() => { elevationInputRef.current?.focus(); }, 100);
                  }
                }}

                filterOptions={(options, params) => {
                  const filtered = options.filter((option) =>
                    option?.planNumberName?.toLowerCase().includes(params.inputValue.toLowerCase())
                  );

                  const inputValue = params.inputValue.trim().toLowerCase();
                  const exactMatch = options.some(
                    (option) => (option?.planNumberName || '').trim().toLowerCase() === inputValue
                  );

                  if (params.inputValue !== '' && !exactMatch) {
                    filtered.push({
                      inputValue: params.inputValue,
                      planNumberName: `Add "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}

                id="plan-autocomplete"
                options={planNumbers}
                getOptionLabel={(option) => {
                  if (typeof option === 'string') return option;
                  if (option.inputValue) return option.planNumberName;
                  return option.planNumberName;
                }}

                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                loading={planLoading}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const isAddOption = !!option.inputValue;

                  return (
                    <li key={key} {...optionProps}>
                      <span style={{ color: isAddOption ? '#1976d2' : 'inherit' }}>
                        {option.planNumberName}
                      </span>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    data-testid="plan-autocomplete-input"
                    {...params}
                    variant="standard"
                    label="Plan #"
                    error={Boolean(errors.planNumber)}
                    helperText={errors.planNumber}
                    inputRef={planInputRef}
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 15,
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {planLoading ? <CircularProgress color="inherit" size={20} sx={{ mr: 2 }} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
              <Typography variant="caption" color="textSecondary">
                This is the identifier the plan was assigned by the builder.
              </Typography>


              <Autocomplete
                sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}
                disabled={!formValues.builder}
                value={elevations.find(e =>
                  e.id === formValues.elevationId ||
                  e.elevationName === formValues.elevation
                ) ?? null}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.id && value.id) return option.id === value.id;
                  return option.elevationName?.trim().toLowerCase() === value.elevationName?.trim().toLowerCase();
                }}
                autoHighlight
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => elevationListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: elevationListboxRef,
                  onMouseMove: () => elevationListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                openOnFocus
                onChange={(event, newValue) => {
                  setFormValues(prev => ({
                    ...prev,
                    elevationId: newValue?.id || "",
                    elevation: newValue?.elevationName || ""
                  }));

                  const input = typeof newValue === 'string' ? newValue : newValue?.inputValue;
                  const builderId = formValues?.builder?.id;

                  if (!builderId) {
                    console.error("Cannot add elevation: builder ID is missing.");
                    return;
                  }

                  const trimmedInput = input?.trim().toLowerCase();
                  const exists = elevations.some(
                    (e) => (e?.elevationName || '').trim().toLowerCase() === trimmedInput
                  );

                  if (exists) {
                    const existingElevation = elevations.find(
                      (e) => (e?.elevationName || '').trim().toLowerCase() === trimmedInput
                    );
                    setFormValues((prev) => ({
                      ...prev,
                      elevation: existingElevation.elevationName,
                      elevationId: existingElevation.id
                    }));

                    setTimeout(() => layoutInputRef.current?.focus(), 100);

                  } else if (input) {
                    setelevationLoading(true);

                    axios.post(GET_ELEVATIONS, {
                      token: localStorage.getItem('token'),
                      addElevation: 'true',
                      builderId,
                      elevationName: input,
                    })
                      .then((response) => {
                        const newElevation = response.data?.message?.elevation;

                        if (response.data.code === 224) { // unarchive, if exists
                          let existingId = response.data.elevationId
                          axios.post(GET_ELEVATIONS, {
                            token: localStorage.getItem('token'),
                            archiveElevation: true,
                            archive: false,
                            id: existingId,
                            builderId: builderId
                          })
                            .then((response) => {
                              console.log(response)

                              setElevations((prev) => [
                                ...prev,
                                {
                                  elevationName: input,
                                  id: existingId,
                                  orgId: localStorage.getItem("orgId"),
                                },
                              ]);

                              setFormValues((prev) => ({
                                ...prev,
                                elevation: input,
                                elevationId: existingId
                              }));

                              setTimeout(() => layoutInputRef.current?.focus(), 100);

                            })
                            .catch((error) => {
                              console.error('Error updating builder archive status:', error);
                            });

                        } else { // add if not exists

                          if (!newElevation || !newElevation.elevationName) {
                            console.error('newElevation or elevationName missing:', newElevation);
                            return;
                          }
                          
                          setElevations((prev) => [
                            ...prev,
                            {
                              elevationName: newElevation.elevationName,
                              id: newElevation.id,
                              orgId: localStorage.getItem("orgId"),
                            },
                          ]);

                          setFormValues((prev) => ({
                            ...prev,
                            elevation: newElevation.elevationName,
                            elevationId: newElevation.id
                          }));

                          setTimeout(() => layoutInputRef.current?.focus(), 100);
                        }
                      })
                      .catch((error) => {
                        console.error('Error creating elevation:', error);
                      })
                      .finally(() => {
                        setelevationLoading(false);
                      });
                  }else {
                    setTimeout(() => layoutInputRef.current?.focus(), 100);
                  }
                }}


                filterOptions={(options, params) => {
                  const filtered = options.filter((option) =>
                    option?.elevationName?.toLowerCase()?.includes(params.inputValue.toLowerCase())
                  );

                  const inputValue = params.inputValue.trim().toLowerCase();
                  const exactMatch = options.some(
                    (option) => option?.elevationName?.trim().toLowerCase() === inputValue
                  );

                  if (params.inputValue !== '' && !exactMatch) {
                    filtered.push({
                      inputValue: params.inputValue,
                      elevationName: `Add "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}

                options={elevations}
                getOptionLabel={(option) => {
                  if (typeof option === 'string') return option;
                  if (option.inputValue) return option.inputValue;
                  return option.elevationName;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const isAddOption = !!option.inputValue;

                  return (
                    <li key={key} {...optionProps}>
                      <span style={{ color: isAddOption ? '#1976d2' : 'inherit' }}>
                        {option.elevationName}
                      </span>
                    </li>
                  );
                }}

                renderInput={(params) => (
                  <TextField
                    data-testid="elevation-autocomplete-input"
                    {...params}
                    value={formValues.elevation || null}
                    variant="standard"
                    label="Elevation (Optional)"
                    inputRef={elevationInputRef}
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 5,
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {elevationLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />

              <Autocomplete
                sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}
                disabled={!formValues.builder}
                value={formValues.layout}
                autoHighlight
                onKeyDown={() => layoutListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: layoutListboxRef,
                  onMouseMove: () => layoutListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                openOnFocus
                onChange={(event, newValue) => {
                  setFormValues((prev) => ({
                    ...prev,
                    layout: newValue || "",
                  }));
                  
                  setTimeout(() => {
                    planOptionsInputRef.current?.focus();
                  }, 100);
                }}
                options={["Left", "Right"]}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                disableClearable={false}
                popupIcon={null}
                clearIcon={<CloseIcon fontSize="small" />}
                renderInput={(params) => (
                  <TextField
                    data-testid="layout-input"
                    {...params}
                    inputRef={layoutInputRef}
                    variant="standard"
                    label="Layout (Optional)"
                  />
                )}
              />

              <Box
                sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}
                variant="standard"
              >
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  disabled={!formValues.builder}
                  freeSolo
                  selectOnFocus
                  autoHighlight
                  openOnFocus
                  clearOnBlur={false}
                  handleHomeEndKeys
                  options={planOptions}
                  value={planOptionValue}
                  componentsProps={{
                    paper: {
                      sx: {
                        '& .MuiAutocomplete-option[aria-selected="true"]': {
                          backgroundColor: '#1976d214 !important',
                          fontWeight: 'bold',
                        },
                        '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                          backgroundColor: '#1976d229 !important',
                          fontWeight: 'bold',
                        },
                        '& .MuiAutocomplete-option.Mui-focused': {
                          backgroundColor: '#0000000a !important',
                          fontWeight: 'normal',
                        },
                        // Only when keyboard-nav class is present
                        '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                          outline: '2px solid #1976d2 !important',
                          outlineOffset: '-2px',
                        },
                      },
                    },
                  }}
                  onKeyDown={() => planOptionsListboxRef.current?.classList.add('keyboard-nav')}
                  ListboxProps={{
                    ref: planOptionsListboxRef,
                    onMouseMove: () => planOptionsListboxRef.current?.classList.remove('keyboard-nav'),
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false;
                    if (option.id && value.id) return option.id === value.id;
                    return (
                      (option.planOptionName || "").trim().toLowerCase() ===
                      (value.planOptionName || "").trim().toLowerCase()
                    );
                  }}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") return option;
                    if (option.inputValue) return option.inputValue;
                    return option.planOptionName;
                  }}
                  filterOptions={(options, params) => {
                    const filtered = options.filter((option) =>
                      option.planOptionName.toLowerCase().includes(params.inputValue.toLowerCase())
                    );

                    const isExisting = options.some(
                      (option) =>
                        option.planOptionName.toLowerCase() === params.inputValue.toLowerCase()
                    );

                    if (params.inputValue !== "" && !isExisting) {
                      filtered.push({
                        inputValue: params.inputValue,
                        planOptionName: `Add "${params.inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  onChange={async (event, newValue) => {
                    const builderId = formValues.builder?.id;
                    if (!builderId) return;

                    const selectedOptionIds = [];
                    const selectedOptionNames = [];
                    const finalValue = [];

                    // Utility: check if already added to finalValue
                    const isAlreadyInFinal = (name) =>
                      finalValue.some(
                        (opt) => opt.planOptionName.trim().toLowerCase() === name.trim().toLowerCase()
                      );

                    for (const item of newValue) {
                      const input = typeof item === "string" ? item : item?.inputValue;

                      if (typeof item === "string" || item?.inputValue) {
                        const trimmed = input.trim().toLowerCase();

                        // Check if it exists in planOptions (including archived)
                        const exists = planOptions.find(
                          (opt) => opt.planOptionName.trim().toLowerCase() === trimmed
                        );

                        if (exists) {
                          // Skip if already added to finalValue
                          if (!isAlreadyInFinal(exists.planOptionName)) {
                            selectedOptionIds.push(exists.id);
                            selectedOptionNames.push(exists.planOptionName);
                            finalValue.push(exists);
                          }
                        } else {
                          // Create new option in DB
                          try {
                            setPlanOptionLoading(true);
                            const response = await axios.post(GET_PLANOPTIONS, {
                              token: localStorage.getItem("token"),
                              createPlanOption: true,
                              builderId,
                              planOptionName: input,
                            });


                            if(response.data.code === 227){ // unarchive, if exists
                              let existingId = response.data.existingPlanOptionId
                              axios.post(GET_PLANOPTIONS, {
                                  token: localStorage.getItem('token'),
                                  archivePlanOption: true,
                                  archive: false,
                                  id: existingId,
                                  builderId: builderId
                              })
                              .then((response) => {
                                
                                var planOption = {
                                    planOptionName: input,
                                    id: existingId,
                                    builderId: builderId,
                                    orgId: localStorage.getItem("orgId"),
                                  }
                                setPlanOptions(prev => [
                                  ...prev, 
                                  planOption
                                ]);
                                selectedOptionIds.push(existingId);
                                selectedOptionNames.push(input);
                                finalValue.push(planOption);

                              })
                              .catch((error) => {
                                  console.error('Error updating builder archive status:', error);
                              });

                            } else { // add new, if not exist
                              const newOpt = response.data?.message?.planoption;

                              if (newOpt && !isAlreadyInFinal(newOpt.planOptionName)) {
                                setPlanOptions(prev => [...prev, newOpt]);
                                selectedOptionIds.push(newOpt.id);
                                selectedOptionNames.push(newOpt.planOptionName);
                                finalValue.push(newOpt);
                              }
                            }
                            setPlanOptionLoading(false);
                          } catch (err) {
                            console.error("Error adding option:", err);
                          }
                        }
                      } else {
                        // Normal option object selected from list
                        if (!isAlreadyInFinal(item.planOptionName)) {
                          selectedOptionIds.push(item.id);
                          selectedOptionNames.push(item.planOptionName);
                          finalValue.push(item);
                        }
                      }
                    }

                    setSelectedPlanOptions(selectedOptionIds);
                    setFormValues((prev) => ({
                      ...prev,
                      option: selectedOptionNames,
                    }));
                    setPlanOptionValue(finalValue);
                  }}

                  renderTags={(selected, getTagProps) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((option, index) => {
                        const tagProps = getTagProps({ index });
                        const { key, ...otherProps } = tagProps;

                        return (
                          <Chip
                            key={key ?? option.id ?? option.planOptionName ?? index}
                            variant="outlined"
                            label={option.planOptionName}
                            {...otherProps}
                            sx={{
                              backgroundColor: "#424242",
                              color: "#fff",
                              ".MuiChip-deleteIcon": {
                                color: "#ccc",
                                "&:hover": { color: "#fff" },
                              },
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}

                  renderOption={(props, option, { selected }) => {
                    const { key, ...otherProps } = props;
                    return (
                      <li key={key} {...otherProps}>
                        <Checkbox
                          style={{ marginRight: 8 }}
                          checked={planOptionValue.some(
                            (opt) => opt.planOptionName === option.planOptionName
                          )}
                        />
                        <span style={{ color: option.inputValue ? '#1976d2' : 'inherit' }}>
                          {option.planOptionName}
                        </span>
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      data-testid="plan-options-input"
                      {...params}
                      variant="standard"
                      label="Plan Options (Optional)"
                      placeholder="Select or add options"
                      inputRef={planOptionsInputRef}
                      inputProps={{
                        ...params.inputProps,
                        maxLength: 40,
                      }}
                      InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {planOptionLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                    />
                  )}
                />

                <Typography variant="caption" color="textSecondary">
                  Options help you identify the different options or variations
                  used in the plan.
                </Typography>
              </Box>

              <Box sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}>
                <Box display="flex" alignItems="center">
                  <TextField
                    data-testid="plan-notes-input"
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <StickyNote2RoundedIcon/>
                          </InputAdornment>
                        ),
                      },
                    }}
                    inputRef={planNotesInputRef}
                    disabled={!formValues.builder}
                    fullWidth
                    label="Plan Notes (Optional)"
                    variant="standard"
                    inputProps={{ maxLength: 500 }}
                    value={formValues.planNotes || ""}
                    onChange={(e) =>
                      setFormValues((prev) => ({
                        ...prev,
                        planNotes: e.target.value,
                      }))
                    }
                  />
                </Box>
                <Typography
                  variant="caption"
                  color="textSecondary"
                >
                  Notes that will help the team in the field.
                </Typography>
              </Box>


            </CardContent>
          </Box>

          <CardActions
            sx={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "background.paper",
              display: "flex",
              width: "552px",
              padding: "24px",
              borderTop: "1px solid #eee",
            }}
          >
            <Button size="medium" variant="contained" onClick={handleSave} loading={saveLoading} loadingPosition="start">
              Save Plan
            </Button>

            <Button
              size="medium"
              variant="outlined"
              onClick={() => saveAndAddNew()}
              sx={{ ml: "8px", mr: "auto" }}
              loading={saveLoading} 
              loadingPosition="start"
            >
              Save & Add New
            </Button>
          </CardActions>
        </Box>
      </Drawer>

      <Dialog
        open={confirmCloseDialog}
        onClose={(event, reason) => {
          // Treat both backdrop click and ESC as Cancel
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            setConfirmCloseDialog(false); // Close dialog
            setShowValidationAlert(false);
          }
        }}
      >
        <DialogTitle>Discard Plan Info?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You have unsaved changes. If you close now, these changes will be
            discarded.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setConfirmCloseDialog(false);
              setShowValidationAlert(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              discardAndClose();
              closeModal();
            }}
            color="error"
          >
            Discard Plan Info
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default AddPlan;